import { render, staticRenderFns } from "./UiFilter.vue?vue&type=template&id=6c3ece1a&scoped=true&"
import script from "./UiFilter.vue?vue&type=script&lang=js&"
export * from "./UiFilter.vue?vue&type=script&lang=js&"
import style0 from "./UiFilter.vue?vue&type=style&index=0&id=6c3ece1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ece1a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiRadio: require('/app/components/UI/UiRadio.vue').default,UiCheckbox: require('/app/components/UI/UiCheckbox.vue').default,UiAccordionItem: require('/app/components/UI/UiAccordionItem.vue').default,UiAccordion: require('/app/components/UI/UiAccordion.vue').default})
